import React from "react";
import AssetVisibleListManager from "../../manager/assetVisible";

const AssetVisiblePage = () => {
    return (
        <AssetVisibleListManager/>
    )
}
export default AssetVisiblePage;